import { AppUser } from '@/types';
import { clearConfigCache } from '../services/configApiClient';

const AUTH_STORAGE_KEY = 'auth_user_session';

export function getStoredUser(): AppUser | null {
  try {
    const stored = localStorage.getItem(AUTH_STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

export function saveStoredUser(user: AppUser | null) {
  clearConfigCache();
  if (user) {
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(user));
  } else {
    localStorage.removeItem(AUTH_STORAGE_KEY);
  }
}

